var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"barrages-drop"}},[_c('vue-baberrage',{attrs:{"isShow":_vm.barrageIsShow,"barrageList":_vm.msgsList,"maxWordCount":_vm.maxWordCount,"throttleGap":_vm.throttleGap,"loop":_vm.barrageLoop,"boxHeight":_vm.boxHeight,"messageHeight":_vm.messageHeight}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66792d06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Barrage.vue
// module id = null
// module chunks = 